<template>
    <v-row v-if="earlyCheckInItems || lateCheckOutItems">
        <v-col cols="12">
            <h4 class="text-subtitle-1 font-weight-bold mb-2">
                {{ $t('earlyCheckInTitle') + '/' + $t('lateCheckOutTitle') }}
            </h4>
            <div class="d-flex">
                <div v-if="checkInFrom || checkInTo" class="d-flex">
                    <div class="font-weight-bold me-1">
                        {{ `${$t('earlyCheckInTitle')}:` }}
                    </div>
                    <div v-if="checkInFrom" class="mx-1">
                        {{ `${$t('time_from')} ${checkInFrom}` }}
                    </div>
                    <div v-if="checkInTo" class="mx-1">
                        {{ `${$t('time_until')} ${checkInTo}` }}
                    </div>
                </div>
                <div v-if="checkOutFrom || checkOutTo" class="ml-4 d-flex">
                    <div class="font-weight-bold me-1">
                        {{ `${$t('lateCheckOutTitle')}:` }}
                    </div>
                    <div v-if="checkOutFrom" class="mx-1">
                        {{ `${$t('time_from')} ${checkOutFrom}` }}
                    </div>
                    <div v-if="checkOutTo" class="mx-1">
                        {{ `${$t('time_until')} ${checkOutTo}` }}
                    </div>
                </div>
            </div>
        </v-col>
        <v-col v-if="earlyCheckInItems" cols="12" md="6">
            <v-select
                :label="$t('earlyCheckIn')"
                :items="earlyCheckInItems"
                item-value="time"
                item-title="name"
                :model-value="checkInExtraServiceSelected"
                clearable
                :disabled="disabled"
                hide-details
                :class="'pt-0'"
                @update:model-value="
                    value => {
                        updateEarlyCheckInOut(value, 'earlyCheckIn')
                    }
                "
            />
        </v-col>
        <v-col v-if="lateCheckOutItems" cols="12" md="6">
            <v-select
                :label="$t('lateCheckOut')"
                :items="lateCheckOutItems"
                item-value="time"
                item-title="name"
                clearable
                hide-details
                :model-value="checkOutExtraServiceSelected"
                :disabled="disabled"
                :class="'pt-0'"
                @update:model-value="
                    value => {
                        updateEarlyCheckInOut(value, 'lateCheckOut')
                    }
                "
            />
        </v-col>
        <v-col cols="12">
            <span class="text-warning">
                {{ $t('early_check_in_attention') }}
            </span>
        </v-col>
    </v-row>
</template>

<script lang="ts">
    import {Component, Emit, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class EarlyCheckInLateCheckOut extends Vue {
        @Prop({default: false}) disabled
        @Prop({required: true}) earlyCheckInItems
        @Prop({required: true}) lateCheckOutItems
        @Prop({required: true}) checkInExtraServiceSelected
        @Prop({required: true}) checkOutExtraServiceSelected
        @Prop({required: false}) checkInFrom
        @Prop({required: false}) checkInTo
        @Prop({required: false}) checkOutFrom
        @Prop({required: false}) checkOutTo

        @Emit()
        updateEarlyCheckInOut(value, type) {
            return {value, type}
        }
    }

    export default EarlyCheckInLateCheckOut
</script>
